// Répète une action tant qu'un bouton est maintenu enfoncé (souris ou tactile, via Pointer
// Events), avec un court délai avant que la répétition démarre pour ne pas gêner un simple tap.
// Un tap isolé exécute l'action une fois ; plusieurs taps rapprochés (relâché entre chaque)
// l'exécutent autant de fois — les deux façons décrites pour, par exemple, couper le son au fil
// des pressions sur "−". Si l'action retourne true, la répétition s'arrête net à ce cran-là (ex.
// le bouton volume qui vient d'atteindre le mute) plutôt que de continuer jusqu'au relâchement.
export function bindHoldRepeat(el, action, { delay = 400, interval = 120 } = {}) {
  let timer = null;

  function stop() {
    clearTimeout(timer);
    clearInterval(timer);
    timer = null;
  }

  function tick() {
    if (action() === true) stop();
  }

  function start(e) {
    e.preventDefault();
    if (action() === true) return; // déjà au cran d'arrêt : pas de répétition à programmer
    timer = setTimeout(() => {
      timer = setInterval(tick, interval);
    }, delay);
  }

  el.addEventListener('pointerdown', start);
  el.addEventListener('pointerup', stop);
  el.addEventListener('pointerleave', stop);
  el.addEventListener('pointercancel', stop);

  return () => {
    stop();
    el.removeEventListener('pointerdown', start);
    el.removeEventListener('pointerup', stop);
    el.removeEventListener('pointerleave', stop);
    el.removeEventListener('pointercancel', stop);
  };
}
